import {
  FETCH_SINGLE_PRODUCT_BEGIN,
  FETCH_SINGLE_PRODUCT_SUCCESS,
  FETCH_SINGLE_PRODUCT_FAILURE
} from '../actions/types';

const initialState = {
  product: null,
  loading: false,
  error: null
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SINGLE_PRODUCT_BEGIN:
      return {
        ...state,
        loading: true,
        product: null,
        error: null
      };
    case FETCH_SINGLE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        product: action.payload.product
      };
    case FETCH_SINGLE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        product: null
      };
    default:
      return state;
  }
}
